import myzxios from '../utils/myaxios'

export function account(data){
    return myzxios({
        url: '/manager/account/getAccount',
        data,
        method: 'POST'
    })
}

export function accountTest(data) {
    return myzxios({
        url: '/manager/account/getAccountTest',
        data,
        method: 'POST'
    })
}

export function accountTestSystem(data) {
    return myzxios({
        url: '/manager/account/getAccountTestSystem',
        data,
        method: 'POST'
    })
}

export function disAccount(data) {
    return myzxios({
        url: '/manager/account/disAccount',
        data,
        method: 'put'
    })
}

export function changePassword(data) {
    return myzxios({
        url: '/manager/account/changePassword',
        data,
        method: 'put'
    })
}

export function resetPassworded(data) {
    return myzxios({
        url: '/manager/account/resetPassworded',
        data,
        method: 'put'
    })
}

export function addAccount(data) {
    return myzxios({
        url: '/manager/account/saveUser',
        data,
        method: 'post'
    })
}

export function removeAccount(data) {
    return myzxios({
        url: '/manager/account/deleteUser',
        params: data,
        method: 'delete'
    })
}

export function getUser(data) {
    return myzxios({
        url: '/manager/account/getUser',
        data,
        method: 'post'
    })
}